export default __webpack_public_path__ + "static/media/ic_upload.f8386cee.svg";